const styles = theme => ({
  sectionLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    fontWeight: 500,
    color: '#002E47',
  },
  optional: {
    fontWeight: 400,
    color: '#919EAB',
  },
  courseInfo: {
    backgroundColor: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '12px',
    padding: '16px 18px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  addSource: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    border: '1px solid rgba(1,95,251,.5)',
    borderRadius: '8px',
    background: '#fff',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: '#015FFB',
    '&:hover': {
      background: 'rgba(1,95,251,.06)',
    },
  },
  courseInfoTitleStart: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    justifyContent: 'space-between',
    width: '100%',
  },
})

export default styles
